import {Component, OnInit} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {IHolidays} from 'src/app/interfaces/settings.iterfaces';
import {DialogService} from 'src/app/services/dialog.service';
import {SettingsService} from 'src/app/services/settings.service';
import {
  columnTypes,
  ITableRowAction,
  UITableHeader,
} from 'src/app/shared/ui-kits/table/table.models';
import {Utils} from 'src/app/shared/utils/utils';
import {HolidaysModalComponent} from './holidays-modal/holidays-modal.component';
import {AccessManagementService} from 'src/app/services/access-management.service';
import {roles} from 'src/app/shared/utils/roles';
import {Router} from '@angular/router';
import {filter} from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-holidays',
  templateUrl: './holidays.component.html',
  styleUrls: ['./holidays.component.scss'],
})
export class HolidaysComponent implements OnInit {
  public tableData: IHolidays[] = [];
  public type = columnTypes;
  public tableHeaders: UITableHeader[] = [
    {key: 'name', index: 0},
    {key: 'date', index: 1, type: columnTypes.datePicker},
    {key: 'id', index: 2, notVisible: true},
    {key: 'comment', index: 3},
  ];
  public formatDate = Utils.formatDateToString;
  public createEmptyObject = Utils.createEmptyObject;
  constructor(
    private settingsService: SettingsService,
    private access: AccessManagementService,
    private router: Router,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.access.checkPermissions([
      ...roles.RECRUITMENT_DEPARTMENT,
      ...roles.DELIVERY_DEPARTMENT,
    ])
      ? this.router.navigate(['settings', 'tech-stacks-and-positions'])
      : this.getHolidayData();
  }

  showDialogWithData(event: ITableRowAction) {
    switch (event.action) {
      case 'edit':
        this.dialogService
          .open(HolidaysModalComponent, {
            data: this.tableData[event.index],
            settings: {
              width: '550px',
              height: '350px',
            },
          })
          .afterClosed()
          .pipe(
            untilDestroyed(this),
            filter(res => !!res)
          )
          .subscribe(res => {
            if (res === 'delete') {
              this.settingsService
                .deleteHoliday(this.tableData[event.index].id)
                .pipe(untilDestroyed(this))
                .subscribe(() => {
                  this.getHolidayData();
                });
              return;
            }
            this.settingsService
              .updateHoliday(res)
              .pipe(untilDestroyed(this))
              .subscribe(() => {
                this.getHolidayData();
              });
          });
        break;
      case 'add':
        this.addNewHoliday();
        break;
    }
  }

  getHolidayData() {
    this.settingsService
      .getAllHolidays()
      .pipe(untilDestroyed(this))
      .subscribe((data: IHolidays[]) => {
        this.tableData = data;
      });
  }

  addNewHoliday() {
    const empty = this.createEmptyObject(this.tableHeaders);
    empty.date = this.formatDate([new Date()]);
    this.dialogService
      .open(HolidaysModalComponent, {
        data: empty,
        settings: {
          width: '500px',
          height: '350px',
        },
      })
      .afterClosed()
      .pipe(
        untilDestroyed(this),
        filter(res => !!res)
      )
      .subscribe(res => {
        this.settingsService
          .addNewHoliday(res)
          .pipe(untilDestroyed(this))
          .subscribe(() => {
            this.getHolidayData();
          });
      });
  }
}
